import { isAuthenticated, login } from '../auth/keycloak';
import { Navigate } from 'react-router';

export function Landing() {
  if (isAuthenticated()) return <Navigate to="/start" replace />;
  return (
    <div className="landing">
      <div className="card">
        <div className="eyebrow">Manu.ia</div>
        <h1>Système d'information des ressources humaines</h1>
        <p className="muted">
          Gestion des agents, des postes, des arrêtés et de la carrière, pour les collectivités de Polynésie française.
        </p>
        <p className="muted small">
          La connexion passe par le portail sécurisé de votre collectivité. Les rôles à responsabilité utilisent une application
          d'authentification en plus du mot de passe.
        </p>
        <button className="btn btn-primary" onClick={() => void login()}>
          Se connecter
        </button>
      </div>
    </div>
  );
}
